module.exports = __webpack_public_path__ + "static/media/stockhausen_haut_6.2ef2a322.jpg";